import React from "react";
import classes from "../components/Blog.module.css";
import blogData from "../pages/Blogs/data";
import Templates from "../pages/Blogs/TemplateData";
import { Link } from "react-router-dom";

export default function BlogTreeView() {
  const RecentPost = [...blogData, ...Templates]
    .sort((a, b) => b.id - a.id)
    .slice(1, 4);
  const allBlogs = [...blogData, ...Templates].sort((a, b) => b.id - a.id);

  return (
    <>
      <div className="mb-3 p-3 bg-white">
        <h5 className={classes.h4}>Recent Posts</h5>
        <div className={classes.List}>
          <ul>
            {RecentPost.map((article) => (
              <>
                <li>
                  <Link
                    className="nav-link"
                    to={`/Article/${article.title
                      .replace(/\s+/g, "-")
                      .toLowerCase()}`}
                  >
                    {article.title}
                  </Link>{" "}
                </li>
              </>
            ))}
          </ul>
        </div>
      </div>

      <div className="p-3 bg-white">
        <h5 className={classes.h4}>Blogs Published</h5>
        <div className={classes.List}>
          {allBlogs.map((posts) => (
            <>
              <ul>
                <li>
                  {" "}
                  <Link
                    className="nav-link"
                    to={`/Article/${posts.title
                      .replace(/\s+/g, "-")
                      .toLowerCase()}`}
                  >
                    {posts.title}
                  </Link>{" "}
                </li>
              </ul>
            </>
          ))}
        </div>
      </div>
    </>
  );
}
